<template>
  <DxPopup
    :visible.sync="localPopupVisible"
    :width="760"
    :height="480"
    :showTitle="true"
    title=""
    :dragEnabled="true"
    :closeOnOutsideClick="true"
    :wrapperAttr="{ class: 'gc-popup-stocktake-batch-count' }"
    :titleTemplate="'titleTemplate'"
    @hidden="onPopupHide"
  >
    <template #titleTemplate>
      <div class="title-template">
        <div class="left">
          <div class="product">
            <span>{{ stockTakeLineData.ProductDescription1 }}</span>
            <span> {{ stockTakeLineData.ProductCode }}</span>
          </div>
          <div class="header">
            <div class="branch">
              <span>Branch:</span>
              <div>
                <span>{{ stockTakeLineData.BranchDescription }}</span>
                <span>{{ stockTakeLineData.BranchCode }}</span>
              </div>
            </div>
            <div class="item">
              <span>Item Count:</span>
              <div>
                <span
                  >{{ getFormattedQty(stockTakeLineData.Count) }} ({{
                    stockTakeLineData.UnitOfMeasureCode
                  }})</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <DxButton
            class="save-btn"
            :text="'Save'"
            type="default"
            :width="105"
            :disabled="!isSaveEnabled"
            @click="SaveBatchCount"
          />
          <DxButton
            class="cancel-btn"
            :text="'Cancel'"
            type="default"
            :width="105"
            @click="onPopupHide"
          />
        </div>
      </div>
    </template>
    <div class="count-content css-v2">
      <div class="error-model" v-if="!isSaveEnabled">
        <svg
          width="22"
          height="20"
          viewBox="0 0 22 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.9995 8.00018V12.0002M10.9995 15.0002H11.0095M9.3625 2.59119L1.2565 16.1252C1.08939 16.4146 1.00096 16.7427 1.00001 17.0768C0.999051 17.411 1.0856 17.7396 1.25104 18.0299C1.41649 18.3203 1.65506 18.5622 1.94304 18.7317C2.23101 18.9013 2.55835 18.9924 2.8925 18.9962H19.1065C19.4405 18.9923 19.7677 18.9011 20.0555 18.7317C20.3433 18.5622 20.5818 18.3204 20.7472 18.0302C20.9126 17.74 20.9992 17.4116 20.9984 17.0776C20.9976 16.7435 20.9094 16.4155 20.7425 16.1262L12.6365 2.59019C12.466 2.30869 12.2257 2.07593 11.9389 1.91439C11.6522 1.75284 11.3286 1.66797 10.9995 1.66797C10.6704 1.66797 10.3468 1.75284 10.06 1.91439C9.77329 2.07593 9.53304 2.30869 9.3625 2.59019V2.59119Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>
          The item count doesn’t match the sum of the batch count. Please verify
          the count for each batch.
        </span>
      </div>
      <div class="gc-details-grid">
        <dx-data-grid
          :height="isSaveEnabled ? 380 : 340"
          :columns="getColumns"
          :data-source="getDataSource"
          ref="dx-data-grid-batch-count"
          :key-expr="'ID'"
          :repaint-changes-only="true"
          :show-borders="true"
          :two-way-binding-enabled="false"
          :focusedRowEnabled="true"
          :column-chooser="{ enabled: false }"
          @editor-preparing="onBatchEditorPreparing"
        >
          <DxSearchPanel :visible="false" />
          <DxPager :visible="false" />
          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>

          <DxEditing
            :allow-adding="false"
            :allow-updating="true"
            :allow-deleting="false"
            mode="cell"
            :select-text-on-edit-start="true"
          />

          <DxSummary>
            <DxTotalItem
              :customize-text="customizeBatchNo"
              column="BatchNo"
              summary-type="count"
            />
            <DxTotalItem
              :customize-text="customizeOnHand"
              column="OnHand"
              summary-type="sum"
              value-format="###,##0.0000"
            />
            <DxTotalItem
              :customize-text="customizeOnHand"
              column="Count"
              summary-type="sum"
              value-format="###,##0.0000"
            />
          </DxSummary>
        </dx-data-grid>
      </div>
    </div>
  </DxPopup>
</template>

<script>
import { DxPopup } from "devextreme-vue";
import ArrayStore from "devextreme/data/array_store";
import { formatNumber } from "devextreme/localization";
import { StocktakeCountService } from "../../_services/api/inventory/stocktake-count.service";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { ProductService } from "../../_services/api/products/product.service";

const batchLine = {
  BatchNo: null,
  SupplierCode: null,
  OnHand: 0,
  Count: 0,
  ManufacturedDate: null,
  ExpiryDate: null,
  IsEdit: true,
  TransactionUMOnHand: 0,
  TransactionUMConversion: 1,
  TransactionUMCount: 0,
  TransactionUM: null,
};

export default {
  components: {
    DxPopup,
  },
  props: {
    popupVisible: {
      type: Boolean,
    },
    stockTakeLineData: {
      type: Object,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: () => {},
    },
    recallFromBatch: {
      type: Function,
      default: () => {},
    },
    mode: {
      type: String,
      default: "review",
    },
  },
  data() {
    return {
      localPopupVisible: this.popupVisible,
      batchCountDataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
    };
  },
  async created() {
    await StocktakeCountService.getStockTakeBatch({
      filter: `StocktakeCode eq ${this.stockTakeLineData.StocktakeCode} and BranchCode eq '${this.stockTakeLineData.BranchCode}' and ProductCode eq '${this.stockTakeLineData.ProductCode}'`,
    }).then((res) => {
      res.data.value.forEach((element) => {
        if (element.Count === 0 && element.OnHand > 0) {
          element.Count = element.OnHand;
        }
        element.TransactionUMConversion =
          this.stockTakeLineData.TransactionUMConversion;
        element.TransactionUM = this.stockTakeLineData.TransactionUM;
        element.TransactionUMOnHand = element.Count
          ? (element.Count / element.TransactionUMConversion).roundNumber(4)
          : 0;
        element.TransactionUMCount = element.Count
          ? (element.Count / element.TransactionUMConversion).roundNumber(4)
          : 0;
        this.batchCountDataSource.insert(element);
      });

      // this.addNewLine();

      const dataGrid = this.$refs["dx-data-grid-batch-count"].instance;
      if (dataGrid) dataGrid.refresh(true);
    });
  },
  watch: {
    popupVisible(val) {
      this.localPopupVisible = val;
    },
    isSaveEnabled() {
      setTimeout(() => {
        const dataGrid = this.$refs["dx-data-grid-batch-count"].instance;
        dataGrid.updateDimensions();
      }, 100);
    },
  },
  methods: {
    onPopupHide() {
      this.localPopupVisible = false;
      this.$emit("update:popupVisible", false);
    },
    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.0000");
    },
    customizeOnHand(e) {
      return e.valueText.replace("Sum: ", "");
    },
    customizeBatchNo() {
      return "Sub Total";
    },
    async SaveBatchCount() {
      const batchData = this.batchCountDataSource._array.filter(
        (x) => x.BatchNo && x.SupplierCode,
      );
      this.showLoading(true);
      let payload = {
        StocktakeCode: this.stockTakeLineData.StocktakeCode,
        ItemCount: (
          this.stockTakeLineData.Count *
          this.stockTakeLineData.TransactionUMConversion
        ).roundNumber(4),
        TransactionUM: this.stockTakeLineData.TransactionUM,
        TransactionUMConversion: this.stockTakeLineData.TransactionUMConversion,
        TransactionUMQty: this.stockTakeLineData.Count,
        ItemCode: this.stockTakeLineData.ProductCode,
        StocktakeCountBatchDetails: batchData.map((x) => {
          return {
            BatchNo: x.BatchNo,
            // BinLocationCode: "strin",
            BranchCode: x.BranchCode,
            Count: x.Count,
            // CountToDate: 0,
            ProductCode: x.ProductCode,
            // ReferenceNo: "string",
            StocktakeCode: x.StocktakeCode,
            // IsBatchProduct: "string",
            SupplierCode: x.SupplierCode,
            // UseByDate: "2025-02-19T06:03:59.380Z",
            // ManufacturedDate: x.ManufacturedDate,
            // ExpiryDate: x.ExpiryDate,
            TransactionUMConversion: x.TransactionUMConversion,
            TransactionUMQty: x.TransactionUMCount,
            TransactionUM: x.TransactionUM,
          };
        }),
      };

      await StocktakeCountService.SaveStocktakeBatchProductCount(payload)
        .then((res) => {
          if (res) this.showLoading(false);
          this.onPopupHide();
          this.$nextTick(() => {
            this.recallFromBatch(true);
          });
        })
        .catch(async (err) => {
          if (err) this.showLoading(false);

          if (
            err.data.ValidationErrors &&
            err.data.ValidationErrors.length > 0
          ) {
            const ex = await this.$alert(
              err.data.ValidationErrors[0].Message,
              "Server Error",
            );
            if (ex) {
              this.onPopupHide();
              this.$nextTick(() => {
                if (err.data.ValidationErrors[0].RefreshData)
                  this.recallFromBatch(true);
              });
            }
          } else this.displayServerError(err);
        });
    },
    onBatchEditorPreparing(e) {
      if (e.dataField && e.dataField === "SupplierCode") {
        e.editorName = "dxSelectBox";
      }
    },
    addNewLine() {
      const dataObj = Object.assign(
        {
          IsCopyLine: false,
          IsNewLine: true,
          BranchCode: this.stockTakeLineData.BranchCode,
          StocktakeCode: this.stockTakeLineData.StocktakeCode,
          ProductCode: this.stockTakeLineData.ProductCode,
        },
        batchLine,
      );

      this.batchCountDataSource.insert(dataObj);
    },
    focusOnBatchEditableCell(rowData, column = "BatchNo") {
      const dataGrid = this.$refs["dx-data-grid-batch-count"].instance;
      const rowIndex = dataGrid.getRowIndexByKey(rowData.ID);

      if (rowIndex != -1) {
        const cellElement = dataGrid.getCellElement(rowIndex, column);
        dataGrid.focus(cellElement);

        setTimeout(() => {
          this.$nextTick(() => {
            dataGrid.editCell(rowIndex, column);
          });
        }, 100);
      }
    },
  },
  computed: {
    getColumns() {
      return [
        {
          caption: "Batch",
          dataField: "BatchNo",
          width: ColumnWidth.BatchNo.width,
          minWidth: ColumnWidth.BatchNo.minWidth,
          allowEditing: false,
          cssClass: "edit-cell-textbox-field",
          setCellValue: (newData, value, currentRowData) => {
            if (!currentRowData.BatchNo) {
              // this.addNewLine();
            }

            newData.BatchNo = value;

            return newData;
          },
        },
        {
          caption: "Suppler Code",
          dataField: "SupplierCode",
          allowEditing: false,
          width: ColumnWidth.SupplierCode.width,
          minWidth: ColumnWidth.SupplierCode.minWidth,
          cssClass: "edit-cell-textbox-field",
          editorOptions: {
            dataSource: ProductService.dataSourceConfig(
              "api/ProductSupplierList",
              {
                filter: [
                  ["ProductCode", "=", this.stockTakeLineData.ProductCode],
                ],
                select: ["SupplierCode", "SupplierName"],
                // sort: "Name asc",
              },
            ),
            displayExpr: "SupplierCode",
            valueExpr: "SupplierCode",
            searchExpr: ["SupplierCode", "SupplierName"],
            searchTimeout: 10,
            searchEnabled: true,
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${data.SupplierCode}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${data.SupplierName}
                        </span>
                      </div>`;
            },
            dropDownOptions: {
              width: 400,
            },
            // onSelectionChanged: (e) => (this.selectedSupplier = e.selectedItem),
            onFocusIn: (e) => {
              e.event.target.select();
            },
          },
        },
        {
          caption: "On Hand",
          dataField: "TransactionUMOnHand",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "###,##0.0000",
          allowEditing: false,
        },
        {
          caption: "Count",
          dataField: "TransactionUMCount",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          format: "###,##0.0000",
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            format: "###,##0.0000",
          },
          setCellValue: async (newData, value, currentRowData) => {
            if (!currentRowData.BatchNo) {
              await this.$alert("Batch Code is required.", "Validation");
              this.focusOnBatchEditableCell(currentRowData);

              return;
            } else if (!currentRowData.SupplierCode) {
              await this.$alert("Supplier Code is required.", "Validation");
              this.focusOnBatchEditableCell(currentRowData, "SupplierCode");

              return;
            } else {
              newData.TransactionUMCount = value;
              newData.Count = (
                value * currentRowData.TransactionUMConversion
              ).roundNumber(4);
              return newData;
            }
          },
        },
        {
          caption: "Manufactured Date",
          dataField: "ManufacturedDate",
          format: "dd MMM yyyy",
          dataType: "date",
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          allowEditing: false,
          cssClass: "edit-cell-textbox-field",
        },
        {
          caption: "Expiry Date",
          dataField: "ExpiryDate",
          format: "dd MMM yyyy",
          dataType: "date",
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          allowEditing: false,
          cssClass: "edit-cell-textbox-field",
        },
      ];
    },
    getDataSource() {
      return this.batchCountDataSource;
    },
    getTotalCounted() {
      return this.batchCountDataSource._array.reduce(
        (sum, item) => sum + item.TransactionUMCount,
        0,
      );
    },
    isSaveEnabled() {
      return this.stockTakeLineData.Count === this.getTotalCounted;
    },
  },
};
</script>

<style lang="scss">
.gc-popup-stocktake-batch-count {
  .title-template {
    display: flex;
    justify-content: space-between;
    padding: 15px;

    .left {
      display: flex;
      flex-direction: column;

      .product {
        padding-bottom: 6px;
        > span:first-child {
          font-family: Roboto;
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: 0%;
          color: var(--colors-text-text-primary-900, #101828);
        }

        > span:last-child {
          padding-left: 5px;
          font-family: Roboto;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          letter-spacing: 0%;
          color: var(--colors-text-text-tertiary-600, #475467);
        }
      }

      .header {
        display: flex;
        justify-content: flex-start;

        .branch,
        .item {
          display: flex;
          flex-direction: row;
          > span:first-child {
            font-family: Roboto;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            letter-spacing: 0%;
            color: var(--Colors-Text-text-placeholder, #667085);
            padding-right: 10px;
          }
        }

        .branch {
          > div {
            > span {
              font-family: Roboto;
              font-weight: 500;
              font-size: 12px;
              line-height: 18px;
              letter-spacing: 0%;
            }
            > span:first-child {
              color: var(--colors-text-text-secondary-700, #323842);
            }

            > span:last-child {
              padding-left: 5px;
              color: var(--Colors-Text-text-placeholder_subtle, #d0d5dd);
            }
          }
        }

        .item {
          padding-left: 15px;
          > div {
            > span {
              font-family: Roboto;
              font-weight: 500;
              font-size: 12px;
              line-height: 18px;
              letter-spacing: 0%;
              color: var(--colors-text-text-secondary-700, #323842);
            }
          }
        }
      }
    }

    .right {
      .save-btn {
        margin-right: 10px;
      }
    }
  }

  .dx-popup-content {
    background-color: #e1e1e9c7;
    padding: 12px !important;
  }

  .error-model {
    background: var(--Colors-Foreground-fg-error-primary, #d92d20);
    padding: 10px;
    display: flex;
    align-items: center;
    height: 40px;

    span {
      padding-left: 8px;
      font-family: Inter;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0%;
      color: var(--Colors-Text-text-white, #ffffff);
    }
  }

  .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row .dx-editor-cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
  .dx-row.dx-footer-row {
    background: var(--Colors-Background-bg-secondary-solid, #323842);
    .dx-datagrid-summary-item {
      color: white;
    }
  }
}
</style>
